import React from 'react';
import Select from 'react-select';
import { fetchClaimedOpsUsers } from '../../../services/api/cashless-physiotherapy-v2';

export default class ClaimedByFilter extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            users: [],
            menuIsOpen: false,
        };
    }

    componentDidMount() {
        fetchClaimedOpsUsers()
            .then((response) => {
                console.log({ response }, 'Fetched OPS Users');
                response.response.unshift({
                    "opsUserId": "unclaimed",
                    "opsUserName": "Unclaimed"
                });

                this.setState({
                    users: response.response,
                });
            })
            .catch((err) => {
                console.error({ err },
                    'Couldnt fetch OPS Users');
                throw err;
            });
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.menuIsOpen !== this.state.menuIsOpen) {
            if (this.state.menuIsOpen) {
                // Prevent scrolling when menu is open
                document.body.style.overflow = 'hidden';
                const reactTableBody = document.querySelector('.rt-tbody');
                if (reactTableBody) {
                    reactTableBody.style.overflow = 'hidden';
                }
            } else {
                // Restore scrolling when menu is closed
                document.body.style.overflow = '';
                const reactTableBody = document.querySelector('.rt-tbody');
                if (reactTableBody) {
                    reactTableBody.style.overflow = '';
                }
            }
        }
    }

    componentWillUnmount() {
        // Cleanup on unmount
        document.body.style.overflow = '';
        const reactTableBody = document.querySelector('.rt-tbody');
        if (reactTableBody) {
            reactTableBody.style.overflow = '';
        }
    }

    onChange = (selectedOption) => {
        this.props.onChange(selectedOption ? selectedOption.value : '');
    };

    handleMenuOpen = () => {
        this.setState({ menuIsOpen: true });
    };

    handleMenuClose = () => {
        this.setState({ menuIsOpen: false });
    };

    render() {
        const { users } = this.state;
        console.log({ users }, 'State');

        const options = [
            { value: '', label: 'All' },
            ...users.map((u) => ({
                value: u.opsUserId,
                label: u.opsUserName
            }))
        ];

        const selectedOption = options.find(opt => opt.value == this.props.value) || options[0];

        return (
            <Select
                value={selectedOption}
                onChange={this.onChange}
                options={options}
                onMenuOpen={this.handleMenuOpen}
                onMenuClose={this.handleMenuClose}
                styles={{
                    control: (provided) => ({
                        ...provided,
                        minHeight: '40px',
                        fontSize: '12px'
                    }),
                    menu: (provided) => ({
                        ...provided,
                        maxHeight: '300px',
                        overflowY: 'auto',
                        zIndex: 9999
                    }),
                    menuList: (provided) => ({
                        ...provided,
                        maxHeight: '300px',
                        overflowY: 'auto'
                    }),
                    option: (provided) => ({
                        ...provided,
                        fontSize: '12px'
                    })
                }}
                menuPlacement="auto"
                menuPosition="fixed"
            />
        );
    }
}

